module.exports = __webpack_public_path__ + "img/23.ec63fc8a.jpg";